export const N = 9;

export const ORBIT_R = 8;

export const ANGLE_STEP = (Math.PI * 2) / N;

export const nodeAngle = (i) => i * ANGLE_STEP;
